import React, { Component } from "react";
import { Jumbotron } from "reactstrap";
import { Animated } from "react-animated-css";
import Footer from "../src/client/components/Footer";
import Menu from "../src/client/components/Menu";
import Navbar from "../src/client/components/Navbar";
import FoodGallery from "./client/components/FoodGallery";
import SliderGlide from "../src/client/components/SliderGlide";
import ContactUs from "../src/client/components/ContactUs";
import Locations from "../src/client/components/Locations";
import Catering from "../src/client/components/Catering";
import DealOfTheMonth from "../src/client/components/DealOfTheMonth";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import AboutUs from "../src/client/components/AboutUs.js";

class Apply extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/ContactUs" component={ContactUs} />
          <Route path="/FoodGallery" component={FoodGallery} />
          <Route path="/Locations" component={Locations} />
          <Route path="/Catering" component={Catering} />
          <Route path="/AboutUs" component={AboutUs} />
        </Switch>
      </Router>
    );
  }
}

const Home = () => (
  <div>
    <Animated
      animationInDelay={100}
      animationIn="bounceInLeft"
      animationOut="bounceInRight"
      isVisible
    >
      <Navbar />
    </Animated>
    <Jumbotron>
      <SliderGlide />
    </Jumbotron>
    <br />
    <Menu />
    <br />
    <br />
    <DealOfTheMonth />
    <br />
    <Footer />
  </div>
);

export default Apply;
